const { Criteria } = Shopware.Data;

export default {
    template: `
<sw-page class="riccardo-magazine-list">
    <template #search-bar>
        <sw-search-bar initial-search-type="riccardo_magazine_post" placeholder="Beitrag suchen" :initial-search="term" @search="onSearch" />
    </template>
    <template #smart-bar-header><h2>Magazin <span v-if="!isLoading">({{ total }})</span></h2></template>
    <template #smart-bar-actions>
        <sw-button variant="primary" :router-link="{ name: 'riccardo.magazine.create' }">Beitrag anlegen</sw-button>
    </template>
    <template #content>
        <sw-entity-listing v-if="posts" :items="posts" :repository="repository" :columns="columns" :is-loading="isLoading"
                           :show-selection="false" detail-route="riccardo.magazine.detail" @page-change="onPageChange">
            <template #column-media="{ item }">
                <sw-media-preview-v2 v-if="item.mediaId" :source="item.mediaId" style="width: 60px; height: 40px" />
                <span v-else style="color:#798490">–</span>
            </template>
            <template #column-title="{ item }">
                <router-link :to="{ name: 'riccardo.magazine.detail', params: { id: item.id } }"><strong>{{ item.title }}</strong></router-link>
                <div style="color:#798490">/magazin/{{ item.slug }}</div>
            </template>
            <template #column-categories="{ item }">{{ (item.categories || []).map(c => c.name).join(', ') || '–' }}</template>
            <template #column-publishedAt="{ item }">{{ formatDate(item.publishedAt) }}</template>
            <template #column-readingMinutes="{ item }">{{ item.readingMinutes ? item.readingMinutes + ' Min' : '–' }}</template>
            <template #column-active="{ item }">
                <sw-icon :name="item.active ? 'regular-checkmark-xs' : 'regular-times-s'" :color="item.active ? '#37d046' : '#de294c'" small />
            </template>
            <template #column-pinned="{ item }">
                <sw-icon v-if="item.pinned" name="regular-star" color="#ffb800" small />
            </template>
            <template #more-actions="{ item }">
                <sw-context-menu-item @click="openInShop(item)">Im Shop ansehen</sw-context-menu-item>
            </template>
        </sw-entity-listing>
    </template>
</sw-page>`,

    inject: ['repositoryFactory'],

    data() {
        return { posts: null, isLoading: false, total: 0, page: 1, limit: 25, term: '' };
    },

    computed: {
        repository() {
            return this.repositoryFactory.create('riccardo_magazine_post');
        },
        columns() {
            return [
                { property: 'media', label: 'Bild', sortable: false, width: '90px' },
                { property: 'title', label: 'Beitrag', primary: true },
                { property: 'categories', label: 'Themen', sortable: false },
                { property: 'publishedAt', label: 'Veröffentlicht' },
                { property: 'readingMinutes', label: 'Lesezeit', align: 'right' },
                { property: 'pinned', label: 'Empfehlung', align: 'center', width: '110px' },
                { property: 'active', label: 'Aktiv', align: 'center', width: '80px' },
            ];
        },
    },

    created() {
        this.getList();
    },

    methods: {
        formatDate(value) {
            return value ? new Date(value).toLocaleDateString('de-DE', { dateStyle: 'medium' }) : '–';
        },
        openInShop(item) {
            window.open(`/magazin/${item.slug}`, '_blank', 'noopener');
        },
        onSearch(term) {
            this.term = term || '';
            this.page = 1;
            this.getList();
        },
        onPageChange({ page, limit }) {
            this.page = page;
            this.limit = limit;
            this.getList();
        },
        getList() {
            this.isLoading = true;
            const criteria = new Criteria(this.page, this.limit);
            criteria.addAssociation('categories');
            criteria.addSorting(Criteria.sort('publishedAt', 'DESC'));
            criteria.setTotalCountMode(1);
            if (this.term) {
                criteria.addFilter(Criteria.multi('OR', [
                    Criteria.contains('title', this.term),
                    Criteria.contains('teaser', this.term),
                    Criteria.contains('slug', this.term),
                ]));
            }
            return this.repository.search(criteria).then((result) => {
                this.posts = result;
                this.total = result.total;
            }).finally(() => { this.isLoading = false; });
        },
    },
};
